import axios from "../../../utils/request"

function ADD_DATA(params) {
    return axios.get("/customer/ACustomerEmail/sendEmail", {
        params: {
            ...params
        }
    } )
}
function SEARCH_CUSTOMER(params) {
    return axios.get("/customer/ACustomerEmail/searchCustomer", {
        params: {
            ...params
        }
    } )
}

function SUMBET_FORM(params) {
    return axios.post("/customer/ACustomerEmail/sendEmailPost",
        {...params}
    )
}

function LETTER_LIST(params) {
    return axios.get("/customer/ACustomerEmail/index", {
        params: {
            ...params
        }
    } )

}
function DELE(params) {
    return  axios.get("/customer/ACustomerEmail/delete",{
        params: {
            ids:params
        }
    } )
}
function ADD_DETAILS_DATA(params) {
    return  axios.get("/customer/ACustomerEmail/detail",{
        params: {
            id:params
        }
    } )
}

export default {
    ADD_DATA,
    SEARCH_CUSTOMER,
    SUMBET_FORM,
    LETTER_LIST,
    DELE,
    ADD_DETAILS_DATA
};
